export default __webpack_public_path__ + "static/media/menuLookup.58385465.svg";